import React from 'react';

import {
    BodyText3,
    FlexColumn,
    H3,
    Image,
    SectionBody,
    SectionHeader,
} from '@portal/common/components';
import { styled } from '@portal/common/theme';

import _ from '../../locale/_';

const Content = styled(FlexColumn)(({ theme }) => ({
    [theme.media.desktop]: {
        marginRight: 318,
    },
}));
const DengueScenariosAboutTab = () => {
    return (
        <SectionBody>
            <SectionHeader>
                <H3>{_(`dengue_scenarios_about_takeda`)}</H3>
            </SectionHeader>
            <Content itemsSpacing={20} grow={1}>
                <BodyText3>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nunc sem,
                    sodales eget eros condimentum, iaculis eleifend ex. Cras ac urna eget dui
                    commodo blandit. Ut blandit purus eget massa euismod, vel bibendum nulla
                    ultrices. Fusce ornare, velit et iaculis ornare, urna nibh fermentum libero, id
                    interdum urna nibh ac ante. Aliquam vitae hendrerit ligula. Donec vitae massa
                    vitae neque vehicula faucibus. Praesent sit amet quam arcu.
                </BodyText3>
                <Image src="img/dengue-scenarios-about.jpeg" />
                <BodyText3>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nunc sem,
                    sodales eget eros condimentum, iaculis eleifend ex. Cras ac urna eget dui
                    commodo blandit. Ut blandit purus eget massa euismod, vel bibendum nulla
                    ultrices. Fusce ornare, velit et iaculis ornare, urna nibh fermentum libero, id
                    interdum urna nibh ac ante. Aliquam vitae hendrerit ligula. Donec vitae massa
                    vitae neque vehicula faucibus. Praesent sit amet quam arcu.
                </BodyText3>
                <BodyText3>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nunc sem,
                    sodales eget eros condimentum, iaculis eleifend ex. Cras ac urna eget dui
                    commodo blandit. Ut blandit purus eget massa euismod, vel bibendum nulla
                    ultrices. Fusce ornare, velit et iaculis ornare, urna nibh fermentum libero, id
                    interdum urna nibh.
                </BodyText3>
            </Content>
        </SectionBody>
    );
};

export default DengueScenariosAboutTab;
